import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function StripeCallbackPage() {
  const navigate = useNavigate()
  const [status, setStatus] = useState('Connecting your Stripe account...')
  const [error, setError] = useState(null)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    const club_id = params.get('state')

    if (!code || !club_id) {
      setError('Invalid callback — missing code or state.')
      return
    }

    const ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY
    const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL

    fetch(`${SUPABASE_URL}/functions/v1/stripe-connect-callback`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${ANON_KEY}`,
        'apikey': ANON_KEY,
      },
      body: JSON.stringify({ code, state: club_id })
    })
    .then(r => r.json())
    .then(async (data) => {
      if (data.error || !data.success) {
        setError(data.error || 'Failed to connect Stripe account.')
        return
      }
      await supabase.from('clubs').update({
        stripe_onboarded: true,
        stripe_connected: true,
      }).eq('id', club_id)
      setStatus('Stripe connected! Redirecting...')
      setTimeout(() => navigate('/app'), 1500)
    })
    .catch(err => {
      setError(err.message || 'Connection failed.')
    })
  }, [navigate])

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8f9fc' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: '2.5rem', maxWidth: 400, width: '90%', border: '1px solid #eee', textAlign: 'center', boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
        {error ? (
          <>
            <div style={{ fontSize: 36, marginBottom: 16 }}>❌</div>
            <div style={{ fontSize: 16, fontWeight: 600, color: '#c00', marginBottom: 8 }}>Connection failed</div>
            <div style={{ fontSize: 13, color: '#888', marginBottom: 20 }}>{error}</div>
            <button onClick={() => navigate('/app')} style={{ background: '#1860a8', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 20px', fontSize: 14, cursor: 'pointer' }}>
              Back to Billing
            </button>
          </>
        ) : (
          <>
            <div style={{ fontSize: 36, marginBottom: 16 }}>⚡</div>
            <div style={{ fontSize: 16, fontWeight: 600, color: '#1a1a1a', marginBottom: 8 }}>{status}</div>
            <div style={{ fontSize: 13, color: '#888' }}>Please wait a moment...</div>
          </>
        )}
      </div>
    </div>
  )
}
